"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatsigSynchronousProvider = exports.Layer = exports.staticImplements = exports.FeatureGate = exports.DynamicConfig = exports.useFeatureGate = exports.useUpdateUser = exports.useStatsigLogEffect = exports.useGateWithExposureLoggingDisabled = exports.useGate = exports.usePrefetchUsers = exports.useLayerWithExposureLoggingDisabled = exports.useLayer = exports.useExperimentWithExposureLoggingDisabled = exports.useExperiment = exports.useConfigWithExposureLoggingDisabled = exports.useConfig = exports.StatsigProvider = exports.StatsigContext = exports.Statsig = void 0;

var statsig_js_1 = require("statsig-js");

Object.defineProperty(exports, "DynamicConfig", {
  enumerable: true,
  get: function get() {
    return statsig_js_1.DynamicConfig;
  }
});
Object.defineProperty(exports, "Layer", {
  enumerable: true,
  get: function get() {
    return statsig_js_1.Layer;
  }
});
Object.defineProperty(exports, "FeatureGate", {
  enumerable: true,
  get: function get() {
    return statsig_js_1.FeatureGate;
  }
});

var Statsig_1 = __importDefault(require("./Statsig"));

exports.Statsig = Statsig_1.default;

var StatsigContext_1 = __importDefault(require("./StatsigContext"));

exports.StatsigContext = StatsigContext_1.default;

var StatsigProvider_1 = __importDefault(require("./StatsigProvider"));

exports.StatsigProvider = StatsigProvider_1.default;

var StatsigStatic_1 = require("./StatsigStatic");

Object.defineProperty(exports, "staticImplements", {
  enumerable: true,
  get: function get() {
    return StatsigStatic_1.staticImplements;
  }
});

var useConfig_1 = __importDefault(require("./useConfig"));

exports.useConfig = useConfig_1.default;

var useExperiment_1 = __importDefault(require("./useExperiment"));

exports.useExperiment = useExperiment_1.default;

var useGate_1 = __importDefault(require("./useGate"));

exports.useGate = useGate_1.default;

var useLayer_1 = __importDefault(require("./useLayer"));

exports.useLayer = useLayer_1.default;

var usePrefetchUsers_1 = __importDefault(require("./usePrefetchUsers"));

exports.usePrefetchUsers = usePrefetchUsers_1.default;

var useStatsigLogEffect_1 = __importDefault(require("./useStatsigLogEffect"));

exports.useStatsigLogEffect = useStatsigLogEffect_1.default;

var StatsigSynchronousProvider_1 = __importDefault(require("./StatsigSynchronousProvider"));

exports.StatsigSynchronousProvider = StatsigSynchronousProvider_1.default;

var useConfigWithExposureLoggingDisabled_1 = __importDefault(require("./useConfigWithExposureLoggingDisabled"));

exports.useConfigWithExposureLoggingDisabled = useConfigWithExposureLoggingDisabled_1.default;

var useGateWithExposureLoggingDisabled_1 = __importDefault(require("./useGateWithExposureLoggingDisabled"));

exports.useGateWithExposureLoggingDisabled = useGateWithExposureLoggingDisabled_1.default;

var useExperimentWithExposureLoggingDisabled_1 = __importDefault(require("./useExperimentWithExposureLoggingDisabled"));

exports.useExperimentWithExposureLoggingDisabled = useExperimentWithExposureLoggingDisabled_1.default;

var useLayerWithExposureLoggingDisabled_1 = __importDefault(require("./useLayerWithExposureLoggingDisabled"));

exports.useLayerWithExposureLoggingDisabled = useLayerWithExposureLoggingDisabled_1.default;

var useUpdateUser_1 = __importDefault(require("./useUpdateUser"));

exports.useUpdateUser = useUpdateUser_1.default;

var useFeatureGate_1 = __importDefault(require("./useFeatureGate"));

exports.useFeatureGate = useFeatureGate_1.default;